export const strings = {
  registrationOverwritten:
    'You have multiple browser tabs open for Contact Center Pro. Only the most recently opened browser tab has phone functionality. Please go to that tab to place or receive phone calls.',
  noActiveWebphone:
    'This tab does not currently have active phone functionality.',
  webPhoneReconnecting:
    'The web phone is connecting. If this takes longer than 10 seconds, please refresh your browser.',
  webPhoneImpersonating:
    'The web phone is disabled by default while impersonating a user.',
  webPhoneConnectionError:
    'There was an issue initializing the webphone connection. Please try to connect again.',
  noActiveWebphoneAction: 'Activate Phone Here',
  webPhoneConnectAction: 'Retry Connection',
} as const;
